export function apiBaseUrl(): string {
  const fromWindow = typeof window !== 'undefined' ? window.PROGETTO_ARCA_API_BASE_URL : ''
  return (fromWindow || import.meta.env.VITE_PROGETTO_ARCA_BACKEND_URL || '').replace(/\/+$/, '')
}

export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const base = apiBaseUrl()
  if (!base) return normalizedPath
  return new URL(normalizedPath, `${base}/`).toString()
}

export function apiAbsoluteUrl(path: string): string {
  const url = apiUrl(path)
  if (/^https?:\/\//i.test(url)) return url
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
  return new URL(url, origin).toString()
}

export function brandAssetUrl(
  filename:
    | 'progetto-arca-lockup.png'
    | 'progetto-arca-mark.png'
    | 'progetto-arca-symbol-white.png'
    | 'luma-ready.svg'
    | 'progetto-arca-symbol-color.png',
): string {
  const base = import.meta.env.BASE_URL || '/'
  return `${base.replace(/\/?$/, '/')}brand/${filename}`
}
